import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import WaitinglistList from "../partials/list/WaitinglistList";
import { BoxContainer } from '../layouts/Theme';
import { useFlow } from '../context/FlowContext';
import { useI18N } from '../context/I18NContext';
import { useConsumerWaitinglists } from '../hooks/query/useConsumerWaitinglists';
export default function Waitinglists(props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const { t } = useI18N();
    const flow = useFlow();
    // this view is outside the flow, so there is no step to take a label from: it puts its own
    // title in the app bar
    const title = t('Wachtlijsten');
    useEffect(() => {
        var _a;
        (_a = flow.setTitle) === null || _a === void 0 ? void 0 : _a.call(flow, title);
    }, [title]);
    const { query, remove } = useConsumerWaitinglists();
    // the same three states the other consumer views have: still loading, failed, or the list.
    // Signing off answers with the list as well, so both write to the same place and the list
    // below is whichever answer came last.
    const result = query.data;
    const failed = ((_a = result === null || result === void 0 ? void 0 : result.status) === null || _a === void 0 ? void 0 : _a.status) === 'failed';
    const waitinglists = failed ? undefined : (_c = (_b = result === null || result === void 0 ? void 0 : result.result) === null || _b === void 0 ? void 0 : _b.item) === null || _c === void 0 ? void 0 : _c.waitinglists;
    // a sign off that did not land leaves the list it returned on screen, and says what happened
    const removeFailed = remove.isError || ((_e = (_d = remove.data) === null || _d === void 0 ? void 0 : _d.status) === null || _e === void 0 ? void 0 : _e.status) === 'failed';
    return (_jsxs(BoxContainer, { children: [query.isFetching && !result && (_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', my: 4 }, children: _jsx(CircularProgress, {}) })), (query.isError || failed) && (_jsx(Alert, { sx: { my: 1 }, severity: "error", children: failed ? t(result.status.message) : t('Je wachtlijsten konden niet worden opgehaald.') })), removeFailed && (_jsx(Alert, { sx: { my: 1 }, severity: "error", children: ((_g = (_f = remove.data) === null || _f === void 0 ? void 0 : _f.status) === null || _g === void 0 ? void 0 : _g.message)
                    ? t(remove.data.status.message)
                    : t('Je kon niet worden afgemeld voor deze wachtlijst.') })), waitinglists && (_jsx(WaitinglistList, { waitinglists: waitinglists, onRemove: (id) => remove.mutate(id), removing: remove.isLoading }))] }));
}
